
export default "/assets/chart-bar-micro.ab5800b3.svg"